import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchCatalogs() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/master-data/catalogs')
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchRecords(ctx, { catalog, params }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/master-data/${catalog}`, { params })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        createRecord(ctx, { catalog, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/master-data/${catalog}`, payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateRecord(ctx, { catalog, id, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/master-data/${catalog}/${id}`, payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        toggleStatus(ctx, { catalog, id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/master-data/${catalog}/${id}/toggle-status`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}
